import { initEditOffer } from '@pages-old/edit-offer/main';
import { isLength } from 'validator';
import { createApp } from 'vue';
import TwigFormValidator from '@tools/twig-form/validator';

export default function (container) {
  const component = {
    mounted() {
      this.initFormValidation();
      initEditOffer();
    },
    methods: {
      initFormValidation() {
        const validator = new TwigFormValidator({
          formSelector: `${container} form`,
          rules: {
            'setup[data][author][phoneNumber]': [ 'required', 'phone' ],
            'setup[data][organization][name]': (value) => [ 'required', isLength(value.trim(), {
              min: 1,
              max: 50,
            }) ],
          },
          messages: {
            'setup[data][author][phoneNumber]': [ 'required', 'invalid' ],
            'setup[data][organization][name]': [ 'required', 'tooLong' ],
          },
        });
        validator.init();
      },
    },
  };

  return createApp(component).mount(container);
}
